import { render, staticRenderFns } from "./CorporateAccountRequestStatusList.vue?vue&type=template&id=5c0390f8&"
import script from "./CorporateAccountRequestStatusList.vue?vue&type=script&lang=ts&"
export * from "./CorporateAccountRequestStatusList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports